import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';

import { AuthenticationService } from '../../shared/services/authentication.service';

import { NavigationService } from 'app/shared/services/navigation.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DfManagementGuard implements CanActivate {

  constructor(
    private authService: AuthenticationService,
    private navigation: NavigationService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.navigation.redirectToHomeIfNotAllowed(() => this.authService.canViewDedicatedFleetManagement());
  }
}
